import React from 'react';
import i18next from "../../i18n.js";
import { backgroundTypes } from '../../constants.js';

export function BackgroundContainer(props) {
    return (<div className={"background " + props.type} >
        {props.type === backgroundTypes.account && <div className="main-circle" />}
        <div className="top-circle" />
        {props.type !== backgroundTypes.general && <div className="bottom-circle" />}
        {props.type === backgroundTypes.account && <div className="top-woman">
            <div className="message">{i18next.t('account.womanMessage')}</div>
            <img src="/img/background/woman.svg" />
        </div>}
        {props.type === backgroundTypes.account && <div className="bottom-man">
            <div className="message">{i18next.t('account.manMessage')}<br />{i18next.t('account.manMessage2')}</div>
            <img src="/img/background/man.svg" />
        </div>}
        {props.children}
    </div>);
}